var map = {
	"./avatar-1.png": 301,
	"./avatar-2.png": 601,
	"./avatar-3.png": 600,
	"./avatar-4.png": 602,
	"./avatar-5.png": 608,
	"./avatar-6.png": 866,
	"./avatar-7.png": 867,
	"./profile.png": 642,
	"./user-round.svg": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;